module.exports = __webpack_public_path__ + "static/media/03.8fea849e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/03.jpg
// module id = 178
// module chunks = 0